var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVntuLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 36,
    viewBox: "0 0 62 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3927 5.87899C54.7644 7.2207 60.8691 25.8521 61 35.0001H53.3822C51.1204 12.618 32.4398 9.25866 23.3822 10.3767L23.6178 12.5113C31.7853 11.1498 38.4869 14.3834 40.8168 16.1705L39.8743 17.1615C33.8429 12.9534 26.6806 13.5785 23.8534 14.4171L26.288 35.0001L22.2827 32.6368L18.356 35.0001L20.555 15.6368C10.1885 20.3938 8.74869 30.5277 9.32461 35.0001H2.96335C3.65445 20.7292 15.2408 14.4679 20.9476 13.1211L21.1047 10.9104C7.87141 14.2646 2.92068 25.6234 2.09948 30.8835L1 30.3498C3.45026 15.7131 15.7906 8.75043 21.6544 7.09871L22.2827 1.00006L23.0681 6.71756C26.2094 5.92473 29.9267 5.82817 31.3927 5.87899Z",
    fill: "#F2F6FF",
    stroke: "#EEF4FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVntuLogo);
export default __webpack_public_path__ + "static/media/Vntu_logo.aaa4db32.svg";
export { ForwardRef as ReactComponent };